import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Button } from 'reactstrap';
import validateLogin from './validateLogin';
import renderField from '../../../shared/components/custom/Field';
import t, { partial } from '../../../util/translation/translation';

const p = partial('EmailLogInForm');
const EmailLogInForm = ({
  handleSubmit,
  loading,
  goToPassword,
  goToForgot,
}) => {
  return (
    <form className="form account__form" onSubmit={handleSubmit}>
      <div id="recaptcha-container" />
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('LogInForm.emailLogin')}
        </span>
        <div className="form__form-group-field mb-2">
          <Field
            name="email"
            component={renderField}
            placeholder={t('EmailLogInForm.email')}
            autoComplete="email"
          />
        </div>
        <div className="form__form-group-field">
          <Field
            name="password"
            component={renderField}
            type="password"
            placeholder={t('shared.password')}
            autoComplete="current-password"
          />
        </div>
        <div className="account__forgot">
          <button type="button" className="account__link" onClick={goToForgot}>
            {t('LogInForm.forgotPassword')}
          </button>
        </div>
      </div>
      <Button color="primary" className="account__submit" disabled={loading}>
        {t('LogInForm.logIn')}
      </Button>
      <div className="account__links">
        <button type="button" className="account__link" onClick={goToPassword}>
          {p('smsLogin')}
        </button>
      </div>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'log_in_form',
  validateLogin,
});

export default reduxF(EmailLogInForm);
